export default __webpack_public_path__ + "static/media/fixture1_footer.c9391f60.png";